<template>
  <div id="nav">
    <nav class="navbar navbar-light navbar-expand-lg" style="background-color: #e3f2fd;">
      <!--a class="navbar-brand" href="/home">{{tittle}}</a-->
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">

          <b-button pill variant="outline-info" href="/home/" class="mb-2" >
            <b-icon icon="house"></b-icon>Home
          </b-button>
          <b-button pill variant="outline-info" href="/users/" class="mb-2" >
            <b-icon icon="person"></b-icon>Usuarios
          </b-button>
          <b-button pill variant="outline-info" href="/clients/" class="mb-2" >
            <b-icon icon="person"></b-icon>Clientes
          </b-button>
          <b-button pill variant="outline-info" href="/tasks/" class="mb-2" >
            <b-icon icon="tag"></b-icon>Categorías
          </b-button>
          <b-button pill variant="outline-info" href="/preguntas/" class="mb-2" >
            <b-icon icon="question-octagon"></b-icon>Preguntas
          </b-button>
          <b-button pill variant="outline-info" href="/reportes/" class="mb-2" >
            <b-icon icon="file-text"></b-icon>Reportes
          </b-button>          
          <b-button pill variant="outline-danger" class="mb-2" @click="desconectar">
            <b-icon icon="power" aria-hidden="true"></b-icon>Logout
          </b-button>

        </ul>
      </div>
    </nav>
  </div>
</template>

<script>


import { logout } from "../api/conection";


export default {
  name: "AppHeader",
  data() {
    return {
      tittle: "Home",      
    };
  },

  methods: {
    desconectar() {
      logout().then(result => {
        window.location.reload();
      });
    },    
  },/*
  computed: {
    btnChanges() {
      return this.buttons.map(btn => btn.state);
    }
  }*/

};
</script>
<style>
/*
#nav-header {  
  display:flex;  
 /* min-width: 100%;
}*/
</style>